// extracted by mini-css-extract-plugin
export const root = "image-composition-quote-module--root--3OLDI";
export const image = "image-composition-quote-module--image--2-yzQ";
export const caption = "image-composition-quote-module--caption--1p5JS";
export const quote = "image-composition-quote-module--quote--3UQF4";